












































import { Blog } from '@/resource/blog/blog.model';
import { Component, Vue, Prop } from 'vue-property-decorator';
import BlogShare from '@/components/blogs/BlogShare.vue';

@Component({
  components: { BlogShare },
})
export default class BlogDetail extends Vue {
  @Prop()
  blog: Blog;

  get detail() {
    if (this.blog) {
      const date = this.$dayjs(this.blog.createdAt);
      return `${date.format('D MMM')}, ${this.blog.duration} minutes read`;
    } else {
      return '';
    }
  }

  get publishByName() {
    return this.blog.publishBy
      ? `${this.blog.publishBy.firstName} ${this.blog.publishBy.lastName}`
      : '';
  }

  get publishByAvatar() {
    return this.blog.publishBy ? this.blog.publishBy.avatar : '';
  }
}
